// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xoyz9YrmeMeM25 {
  position: fixed;
  z-index: 11;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  background: hsla(0, 0%, 0%, 0.6);
}
`, ""]);
// Exports
export var overlay = `xoyz9YrmeMeM25`;
export default ___CSS_LOADER_EXPORT___;
